import React, { useState, useEffect } from "react";
import Collapse from "react-bootstrap/Collapse";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { getItemOfSessionStorage } from "../../services/common/utils";
import { SELECTED_LANG } from "../../services/common/Constants";
const AccordionComponent = ({ type, data, state, banners ={}, pmsitem={}, bgcolor=""}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const language = getItemOfSessionStorage(SELECTED_LANG);
  const [open, setOpen] = useState(false);
  const isViewPacks = useSelector((state) => state?.userdata?.value?.isViewPacks);
  if (type === 1) {
    return (
      <Accordion className="accordion_style_2" defaultActiveKey={["0"]}>
        <Accordion.Item className="accordion_item" eventKey="0">
          <Accordion.Header className="accordion_header">
            <h3 className="primary_16 mb-0">Category</h3>
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/arrow_down_dark.svg"
              }
              alt=""
              title=""
            />
          </Accordion.Header>
          <Accordion.Body className="accordion_collapse">
            <div className="accordion_collapse_in">
              <div className="flex_grp_align_start flex-wrap">
                <div className="cs_check_btn mb-2 me-2">
                  <input
                    type="radio"
                    onChange={() => {
                      if (data) {
                        state(data);
                      }
                    }}
                    name="category"
                    id="category1"
                  />
                  <label htmlFor="category1">All</label>
                </div>
                {data?.map((res) => {
                  return (
                    <div className="cs_check_btn mb-2 me-2">
                      <input
                        onChange={() => state([res])}
                        type="radio"
                        name="category"
                        id={res.id}
                      />
                      <label htmlFor={res.id}>{res.id}</label>
                    </div>
                  );
                })}
                {/* <div className='cs_check_btn mb-2 me-2'>
                                <input type="radio" name="category" id='category3' />
                                <label htmlFor='category3'>Prime Bundles</label>
                            </div> */}
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="accordion_item" eventKey="1">
          <Accordion.Header className="accordion_header">
            <h3 className="primary_16 mb-0">Plan</h3>
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/arrow_down_dark.svg"
              }
              alt=""
              title=""
            />
          </Accordion.Header>
          <Accordion.Body className="accordion_collapse">
            <div className="accordion_collapse_in">
              <div className="flex_grp_align_start flex-wrap">
                <div className="cs_check_btn mb-2 me-2">
                  <input type="checkbox" name="plan" id="plan1" />
                  <label htmlFor="plan1">Test 1</label>
                </div>
                <div className="cs_check_btn mb-2 me-2">
                  <input type="checkbox" name="plan" id="plan2" />
                  <label htmlFor="plan2">Test 2</label>
                </div>
                <div className="cs_check_btn mb-2 me-2">
                  <input type="checkbox" name="plan" id="plan3" />
                  <label htmlFor="plan3">Test 3</label>
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }
  if (type === 2) {
    return (
      <div
        className="card_style_5 mb-10"
        onClick={() =>
          isViewPacks ? navigate(`/roaming-international-rates/${data?.sno}`, { state: data }):
          navigate(`/roaming-inter-rates/${data?.sno}`, { state: data })
        }
      >
        <div
          className="card_style_5_header flex_grp_align_center"
          onClick={() => setOpen(!open)}
          aria-controls="example-collapse-text"
          aria-expanded={open}
        >
          <div className="card_img">
            <img className={isViewPacks ? 'count-img': ''}
              src={
                data?.imageurl !== null
                  ? data?.imageurl
                  : process.env.PUBLIC_URL +
                    "/assets/images/country-logos/Afghanistan-sm.png"
              }
              alt=""
              title=""
            />
          </div>
          <div className="card_info flex1">
            {data?.country} <span dir="ltr">(+{data?.code})</span>
          </div>
          <div className="hyperlink">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/right_arrow_dark.svg"
              }
              alt=""
              title=""
            />
          </div>
        </div>
        <Collapse in={open}>
          <div className="card_style_5_body" id="example-collapse-text">
            <p className="support_text font12 mb-1">
              Supported Passport Operators
            </p>
            <p className="font12 primary_color mb-0">
              Vodafone, Orange, InFlight{" "}
            </p>
          </div>
        </Collapse>
      </div>
    );
  }

  if (type === 3) {
    return (
      <div className="country-accro-comp">
        <div
          className="accordion accordion-flush accrodion-comp2"
          id="accordionFlushExample"
        >
          <div className="accordion-item">
            <h2
              className="accordion-header"
              id="flush-headingOne"
              onClick={() => setOpen(!open)}
              aria-controls="example-collapse-text"
              aria-expanded={open}
            >
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                <div className="d-flex">
                  <div className="profile_info_img profile_info_img1">
                    <img src="assets/images/user.png" alt="" />
                  </div>
                  <div className="d-flex flex-column">
                    <div className="profile_name text-ellipsis primary_18">
                      {" "}
                      Raffi{" "}
                    </div>
                    <label className="message section_title mb-0 text-ellipsis primary_12">
                      66566122
                    </label>
                  </div>
                </div>
              </button>
            </h2>

            <Collapse in={open}>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body1">
                  <div className="main_div">
                    <div>
                      <div className="d-flex profile_info jstcont_spac_btn">
                        <div className="d-flex">
                          <div className="profile_info_img profile_info_img1">
                            <img src="assets/images/user.png" alt="" />
                          </div>
                          <div className="d-flex flex-column align-items-left">
                            <div className="profile_name text-ellipsis primary_16">
                              Raffi
                            </div>
                            <label className="message section_title mb-0 text-ellipsis primary_12">
                              66566122
                            </label>
                          </div>
                        </div>
                        <div className="cs_checkbox_grp">
                          <input
                            type="checkbox"
                            className="custom_checkbox"
                            name=""
                            id="check"
                          />
                          <label for="check">&nbsp;</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="main_div">
                    <div>
                      <div className="d-flex profile_info jstcont_spac_btn">
                        <div className="d-flex">
                          <div className="profile_info_img profile_info_img1">
                            <img src="assets/images/user.png" alt="" />
                          </div>
                          <div className="d-flex flex-column align-items-left">
                            <label className="profile_name text-ellipsis primary_16">
                              Raffi
                            </label>
                            <label className="message section_title mb-0 text-ellipsis primary_12">
                              66566122
                            </label>
                          </div>
                        </div>
                        <div className="cs_checkbox_grp">
                          <input
                            type="checkbox"
                            className="custom_checkbox"
                            name=""
                            id="check1"
                          />
                          <label for="check1">&nbsp;</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
  if (type === 4) {
    //console.log(data, "dateasrwesdfsde")
    return (
      <div
        className="card_style_5 mb-10"
        onClick={() =>
          navigate(`/countries-detail/${data.offerid}`, { state: data })
        }
      >
        <div
          className="card_style_5_header flex_grp_align_center"
          onClick={() => setOpen(!open)}
          aria-controls="example-collapse-text"
          aria-expanded={open}
        >
          <div className="card_img">
            <img
              src={
                data?.imageurl !== null
                  ? data?.imageurl
                  : process.env.PUBLIC_URL +
                    "/assets/images/country-logos/Afghanistan-sm.png"
              }
              alt=""
              title=""
            />
          </div>
          <div className="card_info flex1">
            <p>
              {data?.title}
              <span dir="ltr"> (+{data?.countrydailingcode})&nbsp;</span>
            </p>
          </div>
          <div className="hyperlink">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/right_arrow_dark.svg"
              }
              alt=""
              title=""
            />
          </div>
        </div>
        <Collapse in={open}>
          <div className="card_style_5_body" id="example-collapse-text">
            <p className="support_text font12 mb-1">
              Supported Passport Operators
            </p>
            <p className="font12 primary_color mb-0">
              Vodafone, Orange, InFlight{" "}
            </p>
          </div>
        </Collapse>
      </div>
    );
  }
  if (type === 5) {
    //console.log(data)
    return (
      <div className="card_style_5 mb-10">
        <div
          className="card_style_5_header flex_grp_align_center"
          onClick={() => setOpen(!open)}
          aria-controls="example-collapse-text"
          aria-expanded={open}
        >
          <div className="card_img">
            <img
              src={
                data?.imageurl !== null
                  ? data?.imageurl
                  : process.env.PUBLIC_URL +
                    "/assets/images/country-logos/Afghanistan-sm.png"
              }
              alt=""
              title=""
            />
          </div>
          <div className="card_info flex1">
            <p>{data?.country}</p>
          </div>
          <div className="card_link">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/right_arrow_dark.svg"
              }
              className="rotate_90"
              alt=""
              title=""
            />
          </div>
        </div>
        <Collapse in={open}>
          <div className="card_style_5_body" id="example-collapse-text">
            <p className="support_text font12 mb-1">
              Supported Passport Operators
            </p>
            <p className="font12 primary_color mb-0">{data?.operators} </p>
          </div>
        </Collapse>
      </div>
    );
  }
  //transfer credit

  if (type === 6) {
    return (
      <div
        className="card_style_5 mb-10 pointer"
        onClick={() =>
          navigate(`/transfer-credit-international`, {
            state: data,
          })
        }
      >
        <div
          className="card_style_5_header flex_grp_align_center"
          onClick={() => setOpen(!open)}
          aria-controls="example-collapse-text"
          aria-expanded={open}
        >
          <div className="card_img">
            <img
              src={
                data?.webimage !== null
                  ? data?.webimage
                  : process.env.PUBLIC_URL +
                    "/assets/images/country-logos/Afghanistan-sm.png"
              }
              alt=""
              title=""
            />
          </div>
          <div className="card_info flex1">
            <p>
              {language === "en" ? data?.country : data.country_ar}
              <span dir="ltr"> (+{data?.countrycode})&nbsp;</span>
            </p>
          </div>
          <div className="hyperlink">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/right_arrow_dark.svg"
              }
              alt=""
              title=""
            />
          </div>
        </div>
      </div>
    );
  }
  //roaming journey view packs
  if (type === 7) {
    const handleClick = () =>{
      navigate(`/country_details_packs/${data?.sno}`, {state:{data: data, banners: banners, pmsitem, bgcolor: bgcolor}});
    }
    return (
      <div
        onClick={handleClick}
        className="card_style_5 mb-3 sprint14_card_style_5"
        // onClick={() =>
        //   navigate(`/countries-detail/${data.offerid}`, { state: data })
        // }
      >
        <div
          className="card_style_5_header flex_grp_align_center"
        >
          <div 
          className={`card_img ${language=== 'ar' ? 'm-0' :''}`} >
            <img className="count-img"
              src={
                data?.imageurl !== null
                  ? data?.imageurl
                  : process.env.PUBLIC_URL +
                    "/assets/images/country-logos/Afghanistan-sm.png"
              }
              alt=""
              title=""
            />
          </div>
          <div className="card_info flex1">
            <p>
              {data?.country}
              {/* <span dir="ltr"> (+{data?.countrydailingcode})&nbsp;</span> */}
            </p>
          </div>
          <div className="hyperlink">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/right_arrow_dark.svg"
              }
              alt=""
              title=""
            />
          </div>
        </div>
      </div>
    );
  }
  //passport countries romaing journey flow
  if (type === 8) {
    //console.log(data)
    return (
      <div className="card_style_5 mb-10">
        <div
          className="card_style_5_header flex_grp_align_start"
          onClick={() => setOpen(!open)}
          aria-controls="example-collapse-text"
          aria-expanded={open}
        >
          <div 
           className={`card_img ${language=== 'ar' ? 'm-0' :''}`} >
            <img
              className="count-img"
              src={
                data?.imageurl !== null
                  ? "https://stgweb.ooredoo.com.kw/" +data?.imageurl
                  : process.env.PUBLIC_URL +
                    "/assets/images/country-logos/Afghanistan-sm.png"
              }
              alt=""
              title=""
            />
          </div>
          <div className="card_info flex1 d-grid">
            <p>{data?.country}</p>
            <Collapse in={open}>
          <div className={`card_style_5_body mt-2 ${language=== 'en' ? 'mt-2' :''}`} id="example-collapse-text">
            <p className="support_text font12 mb-1">
              {t("supportoperator")}
            </p>
            <p className="font12 primary_color mb-0">{data?.operators} </p>
          </div>
        </Collapse>
          </div>
          <div className="card_link ">
            <img
              src={
                open? process.env.PUBLIC_URL + "/assets/images/arrow_up_dark_sm.svg":
                process.env.PUBLIC_URL + "/assets/images/arrow_down_dark_sm.svg"
              }
              // className={open ? "rotate_90" : ''}
              alt=""
              title=""
            />
          </div>
        </div>
       
      </div>
    );
  }
};
export default AccordionComponent;
